import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import Annotation from './types/Annotation';
import CodeableConcept from './types/CodeableConcept';
import EffectiveX from './types/EffectiveX';
import AdministrationVariance from './types/AdministrationVariance';
import IdentityVerification from './types/IdentityVerification';
import LimitOverride from './types/LimitOverride';
import MedicationAdministrationDosage from './types/MedicationAdministrationDosage';
import MedicationAdministrationPerformer from './types/MedicationAdministrationPerformer';
import MedicationX from './types/MedicationX';
import Reference from './types/Reference';

export default class MedicationAdministration extends DomainResource {
    static __className = 'MedicationAdministration';

    __objectStructure = {
        status: String, // in-progress | not-done | on-hold | completed | entered-in-error | stopped | unknown
        statusReason: [CodeableConcept],
        category: CodeableConcept,
        medication: MedicationX,
        subject: Reference,
        context: Reference,
        effective: EffectiveX,
        performer: [MedicationAdministrationPerformer],
        reasonCode: [CodeableConcept],
        request: Reference,
        note: [Annotation],
        dosage: MedicationAdministrationDosage,

        // first class extensions
        scheduledDateTime: String, // the slot answered. A record without it is stand-alone and exempt from the double-dose constraint.
        dosageInstructionSequence: Number,
        identityVerification: IdentityVerification,
        // Why a dose that WAS given departed from the order — in time, or in amount. Not
        // statusReason, which means it was not given at all.
        timingVariance: AdministrationVariance,
        doseVariance: AdministrationVariance,
        // A PRN dose given past a limit the order set, with the limit coded so reporting need
        // not re-derive it from an order that may have been edited since.
        limitOverride: LimitOverride,
        administeringLocation: Reference,
        // When this record was entered, which is not when the dose was given. A nurse recording at
        // the window writes the two within a minute of each other; one working from a paper form
        // hours later writes `effective` from the form and this at the moment of entry. Set once at
        // creation and never moved by an amendment.
        recordedAt: String,
    };

    constructor(constructJson, className = 'MedicationAdministration') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
